/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Paper, Tooltip } from '@mui/material';
import RHFInput from 'src/components/elements/Input/RHFInput';
import { useForm } from 'react-hook-form';
import { AiFillCopy } from 'react-icons/ai';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { IoMdMail } from 'react-icons/io';
import { ReferenceLinksProps } from '../../types';
import SendInternalRefMail from '../SendInternalRefMail';

const ReferenceLinksPopup = function ReferenceLinksPopup(
  props: ReferenceLinksProps,
) {
  const {
    jobOrderId, internalLink, externalLink, jobTitle, location, client, shareInternalLink,
  } = props;

  const methods = useForm<ReferenceLinksProps>({});

  const [showMail, setShowMail] = useState(false);
  const [extrnlCopied, setExtrnlCopied] = useState(false);

  const copyLink = () => {
    setExtrnlCopied(true);
    navigator.clipboard.writeText(externalLink);
    setTimeout(() => {
      setExtrnlCopied(false);
    }, 5000);
  };

  const updateShowMail = (val: boolean) => {
    setShowMail(val);
  };

  return (
    <Paper className="px-4 rounded-md text-left" elevation={0}>
      <div className="pb-16 text-secondary text-center text-lg font-bold">
        Reference Links
      </div>

      <div className="pb-16">
        <div className="mb-4">
          <div className="mb-2 text-secondary">Internal Link</div>
          <div className="flex items-center justify-between gap-2">
            <div className="w-full">
              <RHFInput
                name="internalLink"
                value={internalLink}
                control={methods.control}
                disabled
              />
            </div>
            <div
              // onClick={(e) => copyLink('internal')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  // copyLink('internal');
                }
              }}
            >
              <Tooltip title="click to send email" placement="top">
                <div>
                  <IoMdMail
                    className="text-2xl cursor-pointer"
                    color="#F97171"
                    onClick={() => updateShowMail(true)}
                  />
                </div>
              </Tooltip>
            </div>
          </div>
          {showMail && (
            <SendInternalRefMail
              internalLink={internalLink}
              jobOrderId={jobOrderId}
              jobTitle={jobTitle}
              location={location}
              client={client}
              updateShowMail={updateShowMail}
              shareInternalLink={shareInternalLink}
            />
          )}
        </div>
        <div>
          <div className="mb-2 text-secondary">External Link</div>
          <div className="flex items-center justify-between gap-2">
            <div className="w-full">
              <RHFInput
                name="externalLink"
                value={externalLink}
                control={methods.control}
                disabled
              />
            </div>
            <div
              onClick={(e) => copyLink()}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  copyLink();
                }
              }}
            >
              {extrnlCopied ? (
                <Tooltip title="link copied" placement="bottom">
                  <div>
                    <IoCheckmarkCircle
                      className="text-2xl cursor-pointer"
                      color="#F97171"
                    />
                  </div>
                </Tooltip>
              ) : (
                <Tooltip title="copy link" placement="bottom">
                  <div>
                    <AiFillCopy
                      className="text-2xl cursor-pointer"
                      color="#F97171"
                    />
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      </div>
      <div />
    </Paper>
  );
};

export default ReferenceLinksPopup;
